import { Link } from "react-router-dom";
import kiteVideo from "../../../video/kitesurf.mp4";
import styles from "./Home.module.css";
import { useEffect } from "react";

function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className={styles.video_container}>
        <video className={styles.video} autoPlay playsInline loop muted>
          <source src={kiteVideo} type="video/mp4" />
        </video>
        <div className={styles.homeImage}></div>
        <div className={styles.call_to_action + " text-center"}>
          <h1 className={styles.call_to_action_title}>Courage is calling</h1>
          <h4 className={styles.call_to_action_subtitle}>
            Defying gravity. Putting your body on the line. Embracing risk.
          </h4>
        </div>
        <div className={styles.transition}></div>
      </div>
      <div>
        <div className="row p-0 m-0 g-0">
          <>
            <div className={"col-6  col-lg-3 " + styles.category_container}>
              <div className={styles.category}>
                <Link to={`/category/kiteboards`}>
                  <img
                    src={
                      "https://images-ext-2.discordapp.net/external/JYH0B2kQCBQqO9yY_VhPmDSGvNdi9jGEcHUpc8yVQkQ/https/www.f-one.world/app/uploads/2022/09/kite-16.png?width=331&height=663"
                    }
                    alt="kite"
                    className={styles.category_img}
                  />
                  <span className={styles.category_name}>Boards</span>
                </Link>
              </div>
            </div>
            <div className={"col-6  col-lg-3 " + styles.category_container}>
              <div className={styles.category}>
                <Link to={`/category/kites`}>
                  <img
                    src={
                      "https://www.f-one.world/app/uploads/2022/03/HOME-KITEFOIL.png"
                    }
                    alt="kite"
                    className={styles.category_img}
                  />
                  <span className={styles.category_name}>Kites</span>
                </Link>
              </div>
            </div>
            <div className={"col-6  col-lg-3 " + styles.category_container}>
              <div className={styles.category}>
                <Link to={`/category/snowKites`}>
                  <img
                    src="https://www.f-one.world/app/uploads/2022/03/HOME-SURF-FOIL.png"
                    alt="kite"
                    className={styles.category_img}
                  />
                  <span className={styles.category_name}>snowkites</span>
                </Link>
              </div>
            </div>
            <div className={"col-6  col-lg-3 " + styles.category_container}>
              <div className={styles.category}>
                <Link to={`/category/accessories`}>
                  <img
                    src="https://www.f-one.world/app/uploads/2022/03/HOME-WINGFOIL.png"
                    alt="kite"
                    className={styles.category_img}
                  />
                  <span className={styles.category_name}>Accessories</span>
                </Link>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}
export default Home;
